import { useUserStore } from '@/store/user'
import { getData } from '../get-table'
// import { useUserStore } from '@/store/user'

export async function getProcessRequests(): Promise<any> {
  // result
  const response: any = await getData({
    tables: ['pg_process_requests'],
    fields: [
      'process_requests.id',
      'payrolls.name as payroll',
      'processes.code as process',
      'process_status.code as status',
      'processes.color as process_color',
      'process_requests.user',
      'process_requests.employees_amount',
      'process_requests.concepts_amount',
      "TO_CHAR(process_requests.start_date, 'dd/mm/yyyy') as start_date",
      "TO_CHAR(process_requests.end_date, 'dd/mm/yyyy') as end_date",
      'process_requests.created_at',
      'processed_payrolls.id as processed_payroll_id'
    ],
    join: [
      'INNER JOIN payrolls ON process_requests.payroll_id = payrolls.id',
      'INNER JOIN processes ON process_requests.process_id = processes.id',
      'INNER JOIN process_status ON process_requests.process_status_id = process_status.id',
      'LEFT JOIN processed_payrolls ON process_requests.id = processed_payrolls.process_request_id',
      'LEFT JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id'
    ],
    where: [
      'extract(days from (NOW() - process_requests.created_at)) <= 7',
      `process_requests.user_id = '${useUserStore().user?.id ?? ''}'`,
      "(payroll_status.code != 'CLOSED' OR payroll_status IS NULL)"
    ],
    modifier: ['order by process_requests.created_at desc']
  })

  return response[0].results
}
